import * as c from "@yahshi/contracts";
import { createAdminRequest, type AdminHttpOptions } from "../../../lib/adminHttp";

export interface MembershipApi {
  list(query?: Partial<c.AdminMembershipListQuery>): Promise<c.AdminMembershipListResult>;
  get(membershipId: string): Promise<c.AdminMembershipDetail>;
  grant(input: c.AdminGrantMembershipInput): Promise<c.AdminMembershipDetail>;
  cancel(membershipId: string, input: c.CancelMembershipInput): Promise<c.AdminMembershipDetail>;
  listPlans(query?: Partial<c.MembershipPlanListQuery>): Promise<c.MembershipPlanListResult>;
  upsertPlan(input: c.MembershipPlanUpsertInput): Promise<c.MembershipPlan>;
  deletePlan(appId: string, level: string): Promise<c.MembershipPlanDeleteResult>;
  listGrantGroups(): Promise<c.MembershipGrantGroupListResult>;
  upsertGrantGroup(input: c.MembershipGrantGroupUpsertInput): Promise<c.MembershipGrantGroup>;
  deleteGrantGroup(ownerAppId: string): Promise<c.MembershipGrantGroupDeleteResult>;
}

const qs = (value: object) => new URLSearchParams(Object.entries(value).map(([key, item]) => [key, String(item)])).toString();

export function createHttpMembershipApi(options: AdminHttpOptions): MembershipApi {
  const request = createAdminRequest(options);
  return {
    list: (query = {}) => request(`/admin/memberships?${qs(c.adminMembershipListQuerySchema.parse(query))}`, c.adminMembershipListResultSchema),
    get: (membershipId) => request(`/admin/memberships/${encodeURIComponent(membershipId)}`, c.adminMembershipDetailSchema),
    grant: (input) => request("/admin/memberships", c.adminMembershipDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.adminGrantMembershipInputSchema.parse(input)),
    }),
    cancel: (membershipId, input) => request(`/admin/memberships/${encodeURIComponent(membershipId)}/cancel`, c.adminMembershipDetailSchema, {
      method: "POST",
      body: JSON.stringify(c.cancelMembershipInputSchema.parse(input)),
    }),
    listPlans: (query = {}) => request(`/admin/membership-plans?${qs(c.membershipPlanListQuerySchema.parse(query))}`, c.membershipPlanListResultSchema),
    upsertPlan: (input) => request("/admin/membership-plans", c.membershipPlanSchema, {
      method: "PUT",
      body: JSON.stringify(c.membershipPlanUpsertSchema.parse(input)),
    }),
    deletePlan: (appId, level) => request(`/admin/membership-plans/${encodeURIComponent(appId)}/${encodeURIComponent(level)}`, c.membershipPlanDeleteResultSchema, {
      method: "DELETE",
    }),
    listGrantGroups: () => request("/admin/membership-grant-groups", c.membershipGrantGroupListResultSchema),
    upsertGrantGroup: (input) => request("/admin/membership-grant-groups", c.membershipGrantGroupSchema, {
      method: "PUT",
      body: JSON.stringify(c.membershipGrantGroupUpsertSchema.parse(input)),
    }),
    deleteGrantGroup: (ownerAppId) => request(`/admin/membership-grant-groups/${encodeURIComponent(ownerAppId)}`, c.membershipGrantGroupDeleteResultSchema, {
      method: "DELETE",
    }),
  };
}
